import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as jointUse from '../joint-use'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: jointUse.RESOURCE.payload.dimension.partialId,
      partialId: jointUse.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: 'Organization Joint Use Manual Functionalizations',
    isOptional: true,
    name: 'Manual Functionalization',
    partialId: PartialId.Standard.create('manual_functionalization'),
    type: core.common.value.types.Intrinsic.Object,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
